<div class="container-fluid inbuilt-filters-container mb-2" *ngIf="allFilters && allFilters.length > 0">
    <button *ngIf="isJSONeditorEnabled" class="filter-edit-icon" >
        <mat-icon title="Edit filter" (click)="openJsonEditor()">create</mat-icon>
        <mat-icon class="ms-1" title="Delete Report" (click)="deleteReport()">delete</mat-icon>
    </button>
    <div class="row" [ngClass]="{'pt-4': isJSONeditorEnabled}" >
        <div class="col-12 col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 ">
            <div class="row">
                <div class="{{columnClasses[filter.class] || 'col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3'}} mb-2 p-0 pe-2" *ngFor="let filter of allFilters">
                    <div class="filter-field" *ngIf="filter?.name != 'attributes'">
                        <div class="filter-label-row">
                            <label class="section-name" for="{{filter.label}}">{{filter.label}}</label>
                            <div class="filter-label-icons"
                                *ngIf="filter.selectedCount > 0 && (!isApplyClicked || (isApplyClicked && isAnyFilterValueChanged))">
                                <mat-icon class="filter-icon filter-active-icon"
                                    [title]="filter.selectedCount + ' item(s) selected'">schedule</mat-icon>
                                <mat-icon class="filter-icon filter-reset-icon" title="Clear selection"
                                    (click)="clearSingleFilter(filter)">cancel</mat-icon>
                            </div>
                            <div class="dropdown-loader" *ngIf="filter.isLoading && showView">
                                <mat-spinner class="spinner" diameter="24"></mat-spinner>
                            </div>
                        </div>
                        <!-- <span *ngIf="filter.mandatory" class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span> -->
                        <ng-container [ngSwitch]="filter.type">
                            <ng-container *ngSwitchCase="'single-select'">
                               <app-lazy-load-select-dropdown [dropdownData]="filter.dropdownData"
                                    [initialSelectedItems]="filter.default_selection" [searchFlag]="true"
                                    [isMultiselect]="false" [isSelectAll]="false"
                                    [isDataSorted]="filter?.sorted" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name, filter.type)">
                                </app-lazy-load-select-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'multiselect'">
                                <!-- <app-dropdown-with-search searchFlag="true" [Pixeltracking]="true" [showPlaceholder]="'false'"
                        isMultiSelect="true" [dropdownData]="filter.dropdownData" [selected]="filter.initialData"
                        (selectionChange)="setSelectedValues($event,filter.name)">
                    </app-dropdown-with-search> -->
                                <app-lazy-load-select-dropdown [dropdownData]="filter.dropdownData"
                                    [initialSelectedItems]="filter.default_selection" [searchFlag]="true"
                                    [isMultiselect]="true" [isSelectAll]="filter.isSelectedAll"
                                    [isDataSorted]="filter?.sorted" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name, filter.type)">
                                </app-lazy-load-select-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hierarchal'">
                                <!-- <app-multiselect-group-checkbox 
                        [dropdowndataSource]="filter.dropdownData"
                        [hierarchyDropdownConfig]="hierarchyDropdownConfig" 
                        [selectValues]="filter.initialData"
                        [placeholderText]="'Select '"
                        (selectedHierarchy)="setSelectedValues($event,filter.name)">
                    </app-multiselect-group-checkbox> -->
                                <app-hierarchy-dropdown [initialSelectedItems]="filter.default_selection"
                                    [dropdownData]="filter.dropdownData" [filterKey]="getHierarchyDisplayPath(filter)"
                                    [isSelectedAll]="filter.isSelectedAll" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name,filter.type)" [placeholderText]="'Select'"></app-hierarchy-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hierarchal-delimiter'">
                                <app-hierarchy-dropdown [initialSelectedItems]="filter.default_selection"
                                    [dropdownData]="filter.dropdownData" [placeholderText]="'Select'" [filterKey]="getHierarchyDelimiterFilterKey(filter)"
                                    [isSelectedAll]="filter.isSelectedAll" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name,filter.type)"></app-hierarchy-dropdown>
                            </ng-container>
                        </ng-container>
                    </div>

                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 ps-0" *ngIf="elementData?.element_json?.inputBoxSearch">
                    <div class="filter-field search-chip-field p-0">
                        <div class="filter-label-row ">
                            <label class="section-name search-label">{{ searchFieldLabel }}</label>
                            <div class="search-mode-toggle">
                                <span class="search-mode-label">{{ searchModeToggleLabel }}</span>
                                <mat-slide-toggle [checked]="isWildCardSearch"
                                    (change)="onSearchModeToggleChange($event.checked)"></mat-slide-toggle>
                            </div>
                        </div>
                        <mat-form-field appearance="outline" class="search-chip-input-field">
                            <mat-chip-grid #searchChipGrid aria-label="Search values">
                                <mat-chip-row *ngFor="let chip of searchChipValues" (removed)="removeSearchChip(chip)">
                                    {{ chip }}
                                    <button matChipRemove [attr.aria-label]="'remove ' + chip">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>
                                <input #searchChipInputEl placeholder="Type and press enter"
                                    [matChipInputFor]="searchChipGrid"
                                    [matChipInputSeparatorKeyCodes]="searchChipSeparatorKeyCodes"
                                    [disabled]="searchChipValues.length >= maxSearchChipValues"
                                    (matChipInputTokenEnd)="addSearchChip($event)"
                                    (paste)="onSearchChipPaste($event, searchChipInputEl)"
                                    (blur)="onSearchChipInputBlur(searchChipInputEl)">
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 button-block">
            <!-- <div class="col-12 d-flex justify-content-end"> -->
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="resetFilters()" [disabled]="applyLoading">Reset to Default</button>
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="selectAllFilters()" [disabled]="applyLoading">Select All</button>
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="applyFilters()"
                [disabled]="applyLoading || !isAnyFilterSelected || (isApplyClicked && !isAnyFilterValueChanged)">
                <mat-spinner *ngIf="applyLoading" class="search-btn-spinner" diameter="16"></mat-spinner>
                <span *ngIf="!applyLoading">Search</span>
            </button>

            <!-- </div> -->
        </div>

    </div>

</div>

<app-modal [maximizable]="true" [inViewport]="true" #jsonEditorPopup class="modal-demo edit-filter-popup" (closeModal)="closeJsonEditor()">
    <ng-container class="app-modal-header">
        <div class="edit-filter-popup__heading">
            <span class="edit-filter-popup__title">Edit filter</span>
            <span class="edit-filter-popup__subtitle">Update the filter configuration and save your changes.</span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-add-filter-modal #editFilterModalBody
            [editMode]="true"
            [selectedDataSource]="dataSourceJson"
            [reportId]="config?.parentJSON?.id ?? null"
            (cancelled)="onEditFilterCancelled()"
            (filterCreated)="onFilterUpdateRequested($event)">
        </app-add-filter-modal>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="edit-filter-popup__footer">
            <div class="edit-filter-popup__actions" *ngIf="editFilterModalBody?.selectedMenuId !== 'sql-query'">
                <button type="button" class="edit-filter-popup__btn edit-filter-popup__btn--secondary"
                    (click)="editFilterModalBody?.onCancel()">
                    Cancel
                </button>
                <button *ngIf="editFilterModalBody?.selectedMenuId === 'json-editor'" type="button"
                    class="edit-filter-popup__btn edit-filter-popup__btn--secondary"
                    [disabled]="!editFilterModalBody?.canValidateJson" (click)="editFilterModalBody?.onValidateJson()">
                    Validate
                </button>
                <button *ngIf="editFilterModalBody?.selectedMenuId === 'visual-editor'" type="button"
                    class="edit-filter-popup__btn edit-filter-popup__btn--secondary"
                    [disabled]="!editFilterModalBody?.canValidateVisual"
                    (click)="editFilterModalBody?.onValidateVisualJson()">
                    Validate
                </button>
                <button *ngIf="editFilterModalBody?.showPrimaryAction" type="button"
                    class="edit-filter-popup__btn edit-filter-popup__btn--primary"
                    [disabled]="!editFilterModalBody?.canPerformPrimaryAction || editFilterModalBody?.isSaving"
                    (click)="editFilterModalBody?.onPrimaryAction()">
                    {{ editFilterModalBody?.primaryActionLabel }}
                </button>
            </div>
        </div>
    </ng-container>
</app-modal>
